import {BATCH_ACTIONS, PANELMANAGER_CONFIRM_CLOSE_PANEL} from '~/frontend/src/constants';
import showConfirmCloseDialog from '~/frontend/src/actions/panelManager/showConfirmCloseDialog';
import activatePanel from '~/frontend/src/actions/panelManager/activatePanel';

type ConfirmClosePanelAction = {
    type : typeof PANELMANAGER_CONFIRM_CLOSE_PANEL;
    subType : typeof BATCH_ACTIONS;
    panelKey : string;
    actions : any[];
}

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 *
 * @return {ConfirmClosePanelAction}
 */
const confirmClosePanel = ( panelKey : string ) : ConfirmClosePanelAction => {
    return {
        type   : PANELMANAGER_CONFIRM_CLOSE_PANEL,
        subType: BATCH_ACTIONS,
        panelKey,
        actions: [
            {
                type: PANELMANAGER_CONFIRM_CLOSE_PANEL,
                panelKey
            },
            showConfirmCloseDialog( panelKey ),
            activatePanel( panelKey )
        ]
    };
}
export type ConfirmClosePanel = typeof confirmClosePanel;

export default confirmClosePanel;
